import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Login.css"; 

function Login() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const baseUrl = process.env.NODE_ENV === 'production' 
    ? 'https://supply-assist.com' 
    : 'http://localhost:8080';

  return (
    <div className="login-container">
      <div className="login-content">
        <div className="login-box">
          <h1 className="title-supply-assist">
            Supply Assist
          </h1>
          <p className="subtitle">
            配送、供給管理をスマートに
          </p>

          {errorMessage && (
            <div className="error-message">
              {errorMessage}
            </div>
          )}

          <button
            onClick={() => {
              window.location.href = `${baseUrl}/oauth2/authorization/google`;
            }}
            className="google-login-button"
          >
            <img 
              src="https://developers.google.com/identity/images/g-logo.png" 
              alt="Google" 
              className="google-icon" 
            />
            <span>Googleでログイン</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;